import type React from 'react';

import { Box, Text, ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

import { SNOW_REMOVAL } from '../../../../../shared/constants';

type Props = {
  setButtonGroupClick: (fieldName: string, buttonValue: string) => void;
  areaName?: string;
  fieldName: string;
  buttonValue: string;
};

export default function AreaButtonGroup_v1({ setButtonGroupClick, areaName, fieldName, buttonValue }: Props) {
  function onButtonClick(event: React.MouseEvent<HTMLButtonElement>): void {
    const value = event.currentTarget.dataset.value || '';
    setButtonGroupClick(fieldName, value);
  }

  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: { base: '1fr 2fr', sm: '5fr 7fr' },
        gap: 'layout.tighter',
        paddingTop: 'layout.tighter',
        paddingBottom: 'layout.tighter',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        {areaName ? <Text textStyle="body-sm">{areaName}</Text> : <Text>{'Who will be responsible?'}</Text>}
      </Box>
      <Box>
        <ToggleButtonGroup conjoined aria-label="snow removal responsibility" css={{ width: '100%' }}>
          <ToggleButton
            selected={buttonValue === SNOW_REMOVAL.LANDLORD}
            data-value={SNOW_REMOVAL.LANDLORD}
            data-test="AreaButtonGroup-landlord"
            onClick={onButtonClick}
          >
            Landlord
          </ToggleButton>
          <ToggleButton
            selected={buttonValue === SNOW_REMOVAL.TENANT}
            data-value={SNOW_REMOVAL.TENANT}
            onClick={onButtonClick}
          >
            Tenant
          </ToggleButton>
          <ToggleButton selected={buttonValue === SNOW_REMOVAL.NA} data-value={SNOW_REMOVAL.NA} onClick={onButtonClick}>
            N/A
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}
